module.exports = __webpack_public_path__ + "static/media/herobg_14by9.83d143fd.jpg";